// extracted by mini-css-extract-plugin
module.exports = {"list":"EZmyUA0L1RA9kCFVzx55x"};